import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-subpage-lactancia-en-duelo',
  templateUrl: './subpage-lactancia-en-duelo.component.html',
  styleUrls: ['./subpage-lactancia-en-duelo.component.scss']
})
export class SubpageLactanciaEnDueloComponent implements OnInit {

  constructor() { 
    window.scroll(0,0);
  }

  ngOnInit() {
  }

}
